import { render, staticRenderFns } from "./navDrawerForOrganizationPanel.vue?vue&type=template&id=4b5246bb&"
import script from "./navDrawerForOrganizationPanel.vue?vue&type=script&lang=js&"
export * from "./navDrawerForOrganizationPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports